import React from 'react'
import { Helmet } from 'react-helmet';
import '../../Custom.css'
import banner from '../../images/banners/about.jpg'
export default function Bulk_upload() {
  return (
    <div className="improvelive">
      <Helmet>
        <title>Shypv | Bulk Upload </title>
      </Helmet>
      <section className="your_business_page fw" style={{ backgroundImage: `url(${banner})`, backgroundAttachment: 'fixed', backgroundSize: 'cover' }}>
        <div className="container"><div className="row">
          <div className="col-md-12 col-sm-12 your_business text-center">
            <div className="business_content">

              <h1 className='h1-title'>OUR BULK UPLOAD TOOLS</h1>
              <p>We're here to help</p>

            </div>
          </div>
        </div>
        </div>
      </section>
      <div className="pages_content improvelive">
        <div className="container">
          <div className="row">
            <div id="primary" className="content-area" style={{ float: 'left', width: '100%' }}>
              <main id="main" className="site-main" role="main">
                <div className="single_content">
                  <article id="post-287" className="post-287 send type-send status-publish has-post-thumbnail hentry send_categories-about-sending">
                    <div className="become_driver post_driver">
                      <div className="entry-content">
                        <div className="border_text">
                          <h1 style={{ display: 'none' }}>Our Bulk upload tools</h1>
                          <h3>SPREADSHEET UPLOAD SHIPPING TOOLS</h3>
                          <p>Bulk uploading of product information for domestic and international parcels is the modern way of listing items on any e-commerce website as quickly as possible, saving time and increasing profits by getting your products listed online without having to use cumbersome manual methods of transferring data.<br /> And one of the most widely used tools for doing this is to compile a spreadsheet using CSV files.</p>
                        </div>
                        <hr />
                        <div className="border_text">
                          <h3>What is a CSV file?</h3>
                          <p>A CSV file is basically a file in which the different lines of information are separated by a single comma. These allow files including information on products and address details, to be uploaded to a sales website in the shortest possible time<br /> A CSV file is generally much smaller than a standard database file, so can be uploaded much more quickly to a website<br /> The upshot of this is that your products can be listed much more quickly than is possible by using other transfer methods</p>
                        </div>
                        <hr />
                        <div className="border_text">
                          <h3>Upload your CSV</h3>
                          <p>At TIMEDirect, our CSV upload tool is a massive help when you have large quantities of parcels to dispatch. Your business can simply upload data from your own sales information to our system.<br /> This means that we can take the information in your own customer name and address files, and use those to ensure that every parcel is sent using the exact data which is held in your records.<br /> CSVs, or comma-separated values, are the longest established format of information which is input into customer databases.<br /> They ensure that information passed between your business and ours is consistent, and therefore as accurate as possible. And when speed of dispatch is vital to your business’s reputation, and you need to ensure that your parcels are processed as quickly and accurately as possible, your TIMEDirect CSV upload tool offers the shortest route to reliable deliveries, time after time</p>
                        </div>
                      </div>
                    </div>
                    <footer className="entry-footer " />
                  </article>
                  <div className />
                </div>
              </main>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
